export default __webpack_public_path__ + "static/media/psychosis.050f8f76.png";